import * as yup from "yup";

// TODO: restore import.meta.env.VITE_API_BASE_URL — temporary static staging API
const API_BASE_URL = "https://wmapi.global.com.sa/api/v1";

const envSchema = yup.object({
  VITE_API_BASE_URL: yup.string().url("API Base URL must be a valid URL").required(),
});

export const env = envSchema.validateSync({
  VITE_API_BASE_URL: API_BASE_URL,
});
